import { Accounts } from './Accounts';
import { CcyPositions } from './CcyPositions';
import { Exchange } from './constants';

export class Pos {
  clientAccountCurrency: string;
  cashPosition: number;
  netEquityPosition: number;
  netOpenPosition: number;
  unrealizedProfitOrLoss: number;
  ccyPositions: CcyPositions;
  account: Accounts;
  exchange: Exchange;
}
